<div class="btn-group btn-group-sm btn-group-toggle on-off-toggle" name="radioBasic">
  <label class="btn btn-light" data-test-selector="left-option" [ngClass]="{active: !defaultSelection}">
    <input type="radio" [(ngModel)]="defaultSelection"
      (ngModelChange)="updateSelection.emit($event)" [value]="false"/>
    {{ leftOptionText }}
  </label>
  <label class="btn btn-light" data-test-selector="right-option" [ngClass]="{active: defaultSelection}">
    <input type="radio" [(ngModel)]="defaultSelection" [value]="true"
      (ngModelChange)="updateSelection.emit($event)"/>
    {{ rightOptionText }}
  </label>
</div>

